<sh-form-group
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [id]="id"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>
    <div class="sh-form-row-with-action">
        <div class="sh-form-row-with-action__inputs">
            <div class="sh-form-group sh-form-row-with-action__inputs__item">
                <sh-form-number-base [id]="id + '-year'" [formControl]="internalYearControl" [min]="0" [placeholder]="yearLabel"></sh-form-number-base>
            </div>
            <div class="sh-form-group sh-form-row-with-action__inputs__item">
                <sh-form-multi-select-base
                    [id]="id + '-month'"
                    [inOverflownContainer]="inOverflownContainer"
                    [formControl]="internalMonthControl"
                    [options]="monthMultiFormSelectOptions"
                    [placeholderMsg]="monthLabel"
                    [limitHeightToViewport]="limitHeightToViewport"
                ></sh-form-multi-select-base>
            </div>
            <div class="sh-form-group sh-form-row-with-action__inputs__item">
                <sh-form-multi-select-base
                    [id]="id + '-day'"
                    [inOverflownContainer]="inOverflownContainer"
                    [formControl]="internalDayControl"
                    [options]="dayMultiFormSelectOptions$ | async"
                    [placeholderMsg]="dayLabel"
                    [limitHeightToViewport]="limitHeightToViewport"
                ></sh-form-multi-select-base>
            </div>
        </div>
    </div>
</sh-form-group>
